import { IOption } from "../../@types/Option.types";

export const ENROLLER_TYPE_SWITCHER: IOption[] = [
	{
		label: "Enrollments",
		value: "ENROLLMENT"
	},
	{
		label: "Open Enrollments",
		value: "OPEN_ENROLLMENT"
	}
];
